// src/App.js
// Main application component

import React from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import FeaturesSection from './components/sections/FeaturesSection';
import PricingSection from './components/sections/PricingSection';
import ContactSection from './components/sections/ContactSection';
import './assets/styles/App.css';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50 text-gray-900 overflow-hidden dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 dark:text-gray-100">
      {/* Animated Background Blobs */}
      <div className="blob-1" style={{ top: '10%', left: '10%' }}></div>
      <div className="blob-2" style={{ bottom: '20%', right: '10%' }}></div>
      <div className="blob-1" style={{ top: '50%', right: '20%' }}></div>

      {/* Header/Navigation */}
      <Header />

      {/* Main Content */}
      <main>
        <HeroSection />
        <FeaturesSection />
        <PricingSection />
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
